<div>
  <img src="assets/404.jpg">
</div>